// extracted by mini-css-extract-plugin
export var videoContainer = "_j5-0";
export var videoIframe = "_j5-3";
export var videoLink = "_j5-1";
export var videoOverlay = "_j5-4";
export var videoOverlayText = "_j5-5";
export var videoWrapper = "_j5-2";